import React, { useState, useEffect } from "react";
import { FaEdit, FaEye, FaPlus, FaMinus } from "react-icons/fa";
import { calculateTotalFloat, formatRupees, roundNumber } from "../../../../utils/inputsValidation";

import api from "../../../../utils/api";
import Swal from "sweetalert2";
import FundDetailsModal from "../../PortfolioReview/FundDetailsModal";
import { ActionFormModal } from "../../PortfolioReview/modals/ActionFormModal";

export default function HierarchicalTableNew({
  userData,
  isPortfolioData,
  fetchPortfolioData,
  onlyone,
  effectiveValue,
  isChecked,
  setIsChecked,
  rowActions,
  setRowActions,
  schemeCode,
  setSchemeCode,
  allowedReview,
}) {
  // console.log('grandTotalVal', grandTotalVal, allowedReview, isPortfolioData);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showActionModal, setShowActionModal] = useState(false);
  const [showActionFormModal, setShowActionFormModal] = useState(false);
  const [prRowId, setPrRowId] = useState("");

  const [openSipFormAllData, setOpenSipFormAllData] = useState({});
  console.log("openSipFormAllData", openSipFormAllData);

  const [subRowExpandedMobile, setSubRowExpandedMobile] = useState({});
  const [tableExpanded, setTableExpanded] = useState({});

  const [isActionMessage, setIsActionMessage] = useState("");
  const [amcName, setAmcFundList] = useState([]);

  const [currentRowKey, setCurrentRowKey] = useState(null);

  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const [expandedRows, setExpandedRows] = useState({});
  const [selectedGoalDetail, setSelectedGoalDetail] = useState({});
  const [selectedClientreviewedfolio, setSelectedClientreviewedfolio] =
    useState({});


  const [expandedRowKey, setExpandedRowKey] = useState(null);
  const [loadingRowKey, setLoadingRowKey] = useState(null);
  const [folioData, setFolioData] = useState({});

  const [editRowData, setEditRowData] = useState({});
  const [subRowExpanded, setSubRowExpanded] = useState({});
  const [modalContent, setModalContent] = useState("");
  const [viewPrErrors, setViewPrErrors] = useState([]);


  const [openFunds, setOpenFunds] = useState({});

  const toggleFund = (fundKey) => {
    setOpenFunds((prev) => ({
      ...prev,
      [fundKey]: !prev[fundKey],
    }));
  };
  const [openTransactions, setOpenTransactions] = useState({});

  const toggleTransaction = (fundKey) => {
    setOpenTransactions((prev) => ({
      ...prev,
      [fundKey]: !prev[fundKey],
    }));
  };



  const handleToggle = () => {
    setIsChecked((prev) => !prev); // Toggle state
  };
  const folioGoalData = isPortfolioData?.data?.folioGoalData ?? {};

    // ✅ 2. Convert object → array, safely filter only valid goals
    const goalGoalData = Object.entries(folioGoalData)
      .filter(([_, value]) => value?.goalName)
      .map(([key, value]) => ({
        key,
        goalName: value.goalName?.trim() || "Unnamed Goal",
      }));
  // console.log("isPortfolioData", isPortfolioData,schemeCode,prRowId);
  console.log("userData", userData, isPortfolioData);

  const handleEditClick = async (subRowFolio, subRowISIN, fund, rowData, rowData2) => {
    // const rowKey = `${rowData2.folio}_${rowData2.ISIN}`;
    const rowKey = `${subRowFolio}_${subRowISIN}`;

    setCurrentRowKey(rowKey);

    try {
      // Set the row data for editing
      setEditRowData(rowData2);

      // Fetch goal details and client reviewed folio details
      const goalDetail = await getGoalDetail(subRowFolio, subRowISIN);
      const clientReviewedFolio = await getClientreviewedfolio(
        subRowFolio,
        subRowISIN
      );
      console.log("subRowFolio", subRowFolio, subRowISIN, goalDetail, fund, clientReviewedFolio);
      const issip = clientReviewedFolio?.portfolio_type_sip || 0;
      const currentValue = fund?.MarketValue

      // console.log("goalDetail",clientReviewedFolio,goalDetail,issip,currentValue);
      // Initialize variables with default values
      let goalName = "Unmapped";
      let goalId = "";
      let runningSIP = 0;
      let requiredSIP = 0;
      let expectedReturn = 0;
      let targetYear = 0;
      let startYear = 0;
      let targetAmount = 0;
      let aum = 0;
      if (goalDetail) {
        goalName = goalDetail.goalName || goalName;
        goalId = goalDetail.goalId || goalId;
        runningSIP = goalDetail.runningSIP || runningSIP;
        targetAmount = goalDetail.targetAmount || targetAmount;
        aum = goalDetail?.aum || 0;
      }

      // console.log({
      //   goalName,
      //   goalId,
      //   runningSIP,
      //   requiredSIP,
      //   expectedReturn,
      //   targetYear,
      //   startYear,
      //   targetAmount,
      //   aum,
      //   issip,

      // });

      // // Open SIP form with the gathered data
      opensipform(
        fund?.pan_client_id,
        fund?.FundName,
        subRowISIN,
        subRowFolio,
        issip,
        currentValue,
        goalName,
        goalId,
        runningSIP,
        aum,
        requiredSIP,
        expectedReturn,
        targetYear,
        startYear,
        targetAmount
      );

      // Show the edit modal
      setShowEditModal(true);
    } catch (error) {
      console.error("Error handling edit click:", error);
    }
  };

  async function opensipform(
    pan_client_id,
    schemename,
    ISIN,
    portfolioid,
    isSIP,
    currentval,
    goalName,
    goalId,
    runningSIP,
    aum,
    requiredSIP,
    cagr,
    goalYear,
    startYear,
    targetAmount
  ) {
    const allData = {
      pan_client_id: pan_client_id,
      clientid: roomId,
      currentval: currentval,
      schemename: schemename,
      portfolioid: portfolioid,
      ISIN: ISIN,
      isSIP: isSIP,
      moneyformatecurval: currentval,
      goalName: goalName,
      goalId: goalId,
      goalsOption: isPortfolioData?.options?.options,
      runningSIP: runningSIP,
      aum: aum,
      requiredSIP: requiredSIP,
      cagr: cagr,
      goalYear: goalYear,
      startYear: startYear,
      targetAmount: targetAmount,
    };
    console.log("allData", allData);
    setOpenSipFormAllData(allData);
  }

  const toggleRow = (key) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [key]: !prevExpandedRows[key],
    }));
  };

  const fetchViewPrErrors = async (prRowId) => {
    try {
      // Swal.fire({
      //   text: "Please wait...",
      //   imageUrl: 'https://www.finedge.in/assets/images/download.gif',
      //   showConfirmButton: false,
      //   allowOutsideClick: false,
      //   allowEscapeKey: false,
      // });

      const allData = {
        clientid: roomId,
        pr_row_id: prRowId,
      };
      // API Call
      const response = await api.post(`advisor/view_pr_errors`, allData);
      //   console.log("view_pr_errors res",response.data);
      setViewPrErrors(response.data.data);
    } catch (error) {
      console.error("Error fetching portfolio data:", error);
      // Swal.fire({
      //   icon: 'error',
      //   title: 'Oops...',
      //   text: 'Failed to load portfolio data. Please try again later.',
      // });
    } finally {
      // Swal.close(); // Ensure the alert closes in both success and error cases
      setShowActionFormModal(true);
    }
  };

  const toggleSubRow = (key) => {
    setSubRowExpanded((prevSubRowExpanded) => ({
      ...prevSubRowExpanded,
      [key]: !prevSubRowExpanded[key],
    }));
  };

  const getGoalDetail = (folio, ISIN) => {
    const key = `${folio}${ISIN}`;
    const matchedEntry = goalGoalData.find((entry) => entry.key === key);
    console.log("matchedEntry", matchedEntry, key);
    return matchedEntry || {};
  };



  const getAMCFundList = async () => {
    if (amcName.length > 0) return; // Avoid re-calling if already fetched
    // setIsLoadingAMC(true);
    try {
      const response = await api.get(`advisor/master_amc_fund_list`);
      setAmcFundList(response.data || []);
    } catch (error) {
      console.error("Error fetching AMC fund list:", error);
    } finally {
      // setIsLoadingAMC(false);
    }
  };

  useEffect(() => {
    // if (showEditModal) {
    getAMCFundList();
    // }
  }, []);

  // const showFundDetails = async (
  //   schemeCodeData,
  //   clientreviewedfolioData,
  //   rowData2,
  //   schemeCode,
  //   goalName,
  //   goalYear,
  //   fundName,
  //   startYear = new Date().getFullYear()
  // ) => {
  //   // console.log(
  //   //   "schemeCodeData",
  //   //   schemeCodeData,
  //   //   clientreviewedfolioData,
  //   //   goalName,
  //   //   rowData2
  //   // );

  //   const goalDetail = getGoalDetail(rowData2?.folio, rowData2?.ISIN);
  //   const preGoalDetails = isPortfolioData?.goaldeatils[goalDetail?.goalId];
  //   // console.log("schemeCodeData",goalDetail,preGoalDetails);
  //   setShowActionModal(true);
  //   // setModalContent(`<p style="text-align:center;">Loading... <br><img src="/assets/images/download.gif" width="100"/></p>`);

  //   try {
  //     // console.log("fgs", schemeCodeData,clientreviewedfolioData?.stp_fundname)

  //     const params = new URLSearchParams();
  //     params.append("schemeCode", schemeCodeData);

  //     let res;


  //     // ✅ If schemeCodeData is empty or undefined, use get_fund_by_name with JSON body
  //     res = await api.post(
  //       `advisor/get_fund_by_name`,
  //       {
  //         fund_name: clientreviewedfolioData?.stp_fundname,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );


  //     const data = await res.data;

  //     if (!data || data.length === 0) return;

  //     const fund = data;
  //     // console.log("response 12", fund);

  //     if (
  //       fund.Whitelisted !== "true" ||
  //       fund.Time_Horizon === "Temporary Parking"
  //     ) {
  //       const errorMsg =
  //         fund.Whitelisted === "false"
  //           ? "Fund snapshots are only available for whitelisted funds"
  //           : "Fund Snapshots not available for Temporary Parking Funds";
  //       setModalContent(
  //         `<p class="text-danger text-center mt-3">${errorMsg}</p>`
  //       );
  //       return;
  //     }

  //     const currentYear = new Date().getFullYear();
  //     const goalDuration = preGoalDetails?.goalYear - preGoalDetails?.startYear;
  //     let rtn2 =
  //       goalDuration <= 1
  //         ? "5 %"
  //         : goalDuration <= 3
  //           ? "8 %"
  //           : goalDuration <= 4.99
  //             ? "10 %"
  //             : goalDuration <= 6.99
  //               ? "12 %"
  //               : "13 %";

  //     let stmt2 = "";
  //     let rtnText = "";
  //     switch (fund.Time_Horizon) {
  //       case "1-3 Years":
  //         rtnText = "3 YEAR RETURN";
  //         stmt2 = "Short term focus is capital protection.";
  //         break;
  //       case "3-5 Years":
  //         rtnText = "5 YEAR RETURN";
  //         stmt2 = "Staggered entries work well here.";
  //         break;
  //       case "Above 5 Years":
  //         rtnText = "10 YEAR RETURN";
  //         stmt2 = "Invest monthly through SIPs or STPs.";
  //         break;
  //     }

  //     let SIRtn = fund.return_since_inception?.trim() || "Unavailable";

  //     if (!goalName?.toLowerCase().includes("goal")) goalName += " Goal";
  //     const goalName2 = ["marriage", "graduation"].some((g) =>
  //       clientreviewedfolioData.goal_name?.toLowerCase().includes(g)
  //     )
  //       ? clientreviewedfolioData.goal_name
  //       : "Your " + clientreviewedfolioData.goal_name;

  //     let riskProfile = fund.Risk_Profile?.replace(" Funds", "") || "";
  //     riskProfile = (riskProfile === "Aggressive" ? "an " : "a ") + riskProfile;

  //     const html = `
  //       <div style="max-height: 600px; overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none;">
  //         <div class="row">
  //           <div class="col-sm-2 text-center"><img src="/assets/images/fund-scheme.png" style="width: 6vw;"></div>
  //           <div class="col-sm-8 text-dark pt-3 text-center">
  //             <div style="font-size:1.7vw;"><strong>${clientreviewedfolioData.goal_name
  //       } | Year ${preGoalDetails?.goalYear}</strong></div>
  //             <div style="font-size: 1.3vw;">${fund.fund_name}</div>
  //           </div>
  //         </div><br>
  //         <div class="row text-center mb-3">
  //           <div class="col-sm-4 text-dark"><strong>FUND SIZE</strong><br><span class="text-success fs-5 fw-bold">${fund.fund_size
  //       }</span></div>
  //           <div class="col-sm-4 text-dark"><strong>INVESTMENT HORIZON</strong><br><span class="text-success fs-5 fw-bold">${fund.investment_horizon
  //       }</span></div>
  //           <div class="col-sm-4 text-dark"><strong>RETURN SINCE INCEPTION</strong><br><span class="text-success fs-5 fw-bold">${SIRtn}</span></div>
  //         </div>
  //         <div class="row d-flex justify-content-between text-center mb-3">
  //           <div class="col-sm-4 text-dark"><strong>CATEGORY</strong><br><span class="text-success fs-5 fw-bold">${fund.Sub_Category
  //       }</span></div>
  //           <div class="col-sm-4 text-dark"><strong>RETURN REQUIRED TO ACHIEVE GOAL</strong><br><span class="text-success fs-5 fw-bold">${rtn2}</span></div>
  //         </div>
  //         <hr>
  //         <div class="row">
  //           <div class="col-sm-8">
  //             <div style="background: #fff1e8;border: .7vw solid #ffd1d1;min-height: 13vw;">
  //               <span class="fs-5 fw-bold text-success">RECOMMENDATION RATIONALE</span>
  //               <ul class="small mt-2 ms-3 text-justify">
  //                 ${[
  //         fund.rationale1,
  //         fund.rationale2,
  //         fund.rationale3,
  //         fund.rationale4,
  //         fund.rationale5,
  //       ]
  //         .map((r) => `<li>${r}</li>`)
  //         .join("")}
  //               </ul>
  //             </div>
  //           </div>
  //           <div class="col-sm-4">
  //             <span class="fs-5 fw-bold text-success">SUMMARY</span>
  //             <img src="/assets/images/fund_scheme_bulb.png" style="width: 3.5vw;">
  //             <hr>
  //             <p style="font-size: 1vw;">${goalName2} is ${preGoalDetails?.goalYear - currentYear
  //       } years away. We recommend ${riskProfile} fund like ${fundName}. ${stmt2}</p>
  //           </div>
  //         </div>
  //         <div>
  //         <span class="fs-5 fw-bold text-success">OUR PHILOSOPHY</span>
  //         <ul class="small mt-2 ms-3 text-justify text-dark">
  //                 ${[
  //         fund.philosophy1,
  //         fund.philosophy2,
  //         fund.philosophy3,
  //         fund.philosophy4,
  //         fund.philosophy5,
  //       ]
  //         .map((r) => `<li>${r}</li>`)
  //         .join("")}
  //               </ul>
  //         </div>
  //       </div>
  //     `;

  //     setModalContent(html);
  //   } catch (err) {
  //     console.error(err);
  //     setModalContent(
  //       `<p class="text-danger text-center mt-3">Something went wrong</p>`
  //     );
  //   }
  // };

  // console.log("actionNamedfgdfg", actionName)


  const [showModal, setShowModal] = useState(false);
  const showFundDetails = async (fundName, goalName, goalYear, startyear = new Date(), ISIN) => {

    setShowModal(true);
    try {
      const res = await api.post(
        `advisor/get_fund_by_name`,
        {
          // fund_name: fundName,
          ISIN: ISIN
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.data;

      if (!data || data.length === 0) return;

      const fund = data;
      console.log(' andfundName ', fund, fundName, goalName);

      if (
        fund.Whitelisted !== "true" ||
        fund.Time_Horizon === "Temporary Parking"
      ) {
        const errorMsg =
          fund.Whitelisted === "false"
            ? "Fund snapshots are only available for whitelisted funds"
            : "Fund Snapshots not available for Temporary Parking Funds";
        setModalContent(
          `<p class="text-danger text-center mt-3">${errorMsg}</p>`
        );
        return;
      }

      const currentYear = new Date().getFullYear();
      const goalDuration = goalYear - startyear;
      let rtn2 =
        goalDuration <= 1
          ? "5 %"
          : goalDuration <= 3
            ? "8 %"
            : goalDuration <= 4.99
              ? "10 %"
              : goalDuration <= 6.99
                ? "12 %"
                : "13 %";

      let stmt2 = "";
      let rtnText = "";
      switch (fund.Time_Horizon) {
        case "1-3 Years":
          rtnText = "3 YEAR RETURN";
          stmt2 = "Short term focus is capital protection.";
          break;
        case "3-5 Years":
          rtnText = "5 YEAR RETURN";
          stmt2 = "Staggered entries work well here.";
          break;
        case "Above 5 Years":
          rtnText = "10 YEAR RETURN";
          stmt2 = "Invest monthly through SIPs or STPs.";
          break;
      }

      let SIRtn = fund.return_since_inception?.trim() || "Unavailable";

      if (!goalName?.toLowerCase().includes("goal")) goalName += " Goal";
      console.log("response 12 h", fund);

      const goalName2 = ["marriage", "graduation"].some((g) =>
        (goalName?.toLowerCase().includes(g))
          ? goalName
          : "Your " + goalName)
      console.log("response 12 g", fund);

      let riskProfile = fund.Risk_Profile?.replace(" Funds", "") || "";
      riskProfile = (riskProfile === "Aggressive" ? "an " : "a ") + riskProfile;

      const html = `
          <div style="max-height: 600px; overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none;">
            <div class="row">
              <div class="col-sm-2 text-center"><img src="/assets/images/fund-scheme.png" style="width: 6vw;"></div>
              <div class="col-sm-8 text-dark pt-3 text-center">
                <div style="font-size:1.7vw;"><strong>${goalName} | Year ${(goalYear || currentYear)
        }</strong></div>
                <div style="font-size: 1.3vw;">${fund.fund_name}</div>
              </div>
            </div><br>
            <div class="row text-center mb-3">
              <div class="col-sm-4 text-dark"><strong>FUND SIZE</strong><br><span class="text-success fs-5 fw-bold">${fund.fund_size
        }</span></div>
              <div class="col-sm-4 text-dark"><strong>INVESTMENT HORIZON</strong><br><span class="text-success fs-5 fw-bold">${fund.investment_horizon
        }</span></div>
              <div class="col-sm-4 text-dark"><strong>RETURN SINCE INCEPTION</strong><br><span class="text-success fs-5 fw-bold">${SIRtn}</span></div>
            </div>
            <div class="row d-flex justify-content-between text-center mb-3">
              <div class="col-sm-4 text-dark"><strong>CATEGORY</strong><br><span class="text-success fs-5 fw-bold">${fund.Sub_Category
        }</span></div>
              <div class="col-sm-4 text-dark"><strong>RETURN REQUIRED TO ACHIEVE GOAL</strong><br><span class="text-success fs-5 fw-bold">${rtn2}</span></div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-8">
                <div style="background: #fff1e8;border: .7vw solid #ffd1d1;min-height: 13vw;">
                  <span class="fs-5 fw-bold text-success">RECOMMENDATION RATIONALE</span>
                  <ul class="small mt-2 ms-3 text-justify">
                    ${[
          fund.rationale1,
          fund.rationale2,
          fund.rationale3,
          fund.rationale4,
          fund.rationale5,
        ]
          .map((r) => `<li>${r}</li>`)
          .join("")}
                  </ul>
                </div>
              </div>
              <div class="col-sm-4">
                <span class="fs-5 fw-bold text-success">SUMMARY</span>
                <img src="/assets/images/fund_scheme_bulb.png" style="width: 3.5vw;">
                <hr>
                <p style="font-size: 1vw;">${goalName} is ${(goalYear || currentYear) - currentYear
        } years away. We recommend ${riskProfile} fund like ${fundName}. ${stmt2}</p>
              </div>
            </div>
            <div>
            <span class="fs-5 fw-bold text-success">OUR PHILOSOPHY</span>
            <ul class="small mt-2 ms-3 text-justify text-dark">
                    ${[
          fund.philosophy1,
          fund.philosophy2,
          fund.philosophy3,
          fund.philosophy4,
          fund.philosophy5,
        ]
          .map((r) => `<li>${r}</li>`)
          .join("")}
                  </ul>
            </div>
          </div>
        `;

      setModalContent(html);
    } catch (err) {
      console.error(err);
      setModalContent(
        `<p class="text-danger text-center mt-3">Something went wrong</p>`
      );
    }
  };
  const getClientreviewedfolio = (folio, ISIN) => {

    console.log(" Folio:",folio, ISIN, isPortfolioData);
    const clientreviewedfolio = isPortfolioData?.data?.clientreviewedfolio;
    console.log(" Folio:1",clientreviewedfolio);

    if (!clientreviewedfolio || !Array.isArray(clientreviewedfolio)) {
      console.error("Client folio data is not available or not an array.");
      return null;
    }

    // Finding the matching object
    const matchingFolio = clientreviewedfolio.find(
      (clientFolio) =>
        clientFolio.portfolio_id === folio &&
        clientFolio.portfolio_ISIN === ISIN
    );

    if (matchingFolio) {
      // console.log("Matching Folio:", matchingFolio);
      return matchingFolio;
    } else {
      return null;
    }
  };

  useEffect(() => {
    // Automatically expand all rows on load

    const initialExpandedRows = {};
    // userData?.forEach((item, index) => {
    //   const mainKey = `0-${index}`;
    //   initialExpandedRows[mainKey] = true;

    //   if (item.Detail) {
    //     item.Detail.forEach((subItem, subIndex) => {
    //       const subKey = `0-${index}-sub-${subIndex}`;
    //       initialExpandedRows[subKey] = false; // Initially, sub-items are collapsed
    //     });
    //   }
    // });

    setExpandedRows(initialExpandedRows);
  }, [userData]);

  function calculateEffectiveBalance(transactions, fundnametype, fundSubName) {
    let effiBal = 0;
    let fromDate = new Date();
    console.log('transactions', fundnametype, transactions, fundSubName);

    // 🧠 Apply fund type rules to determine cutoff date
    if (
      (fundnametype === "Equity" && fundSubName !== "Equity - ELSS") ||
      (fundnametype === "Hybrid" && fundSubName !== "Hybrid - Arbitrage")
    ) {
      fromDate.setMonth(fromDate.getMonth() - 12); // 12 months ago
    } else if (
      fundnametype === "Debt" ||
      fundnametype === "Hybrid - Arbitrage" ||
      fundnametype === "Others"
    ) {
      // keep current date (no backdate)
    } else {
      fromDate.setMonth(fromDate.getMonth() - 36); // 36 months ago
    }

    // ✅ Allow flexible transaction type matching
    const validTypes = ["SIP Purchase", "Purchase", "STP In", "STP In Installment No", "Switch In"];

    (transactions || []).forEach((tx) => {
      const rawDate = tx.TransactionDate;
      if (!rawDate) return;

      // Handle DD/MM/YYYY or DD-MM-YYYY
      const parts = rawDate.includes("/") ? rawDate.split("/") : rawDate.split("-");
      if (parts.length !== 3) return;

      let [dd, mm, yy] = parts;

      // Normalize year
      if (yy.length === 2) yy = `20${yy}`;
      if (mm.length === 1) mm = `0${mm}`;
      if (dd.length === 1) dd = `0${dd}`;

      const txDate = new Date(`${yy}-${mm}-${dd}`);

      const isValidType = validTypes.some((type) => tx.Description?.startsWith(type));

      if (!isNaN(txDate) && isValidType && txDate < fromDate) {
        effiBal += parseFloat(tx.curr_val) || 0;
      }
    });

    return effiBal;
  }


  const calculateEffiBalTotal = (val) => {
    let total = 0;

    userData?.forEach((user) => {
      const portfoioData = user?.Portfoio ? Object.values(user?.Portfoio) : [];

      portfoioData?.forEach((item) => {
        item?.Detail?.forEach((subFund) => {
          subFund?.Detail?.forEach((subFundDetail) => {
            const txns = subFundDetail?.Transaction || [];
            const fundnametype = item["Fund Name"];
            const fundSubName = subFund["Fund Sub Name"];
            let fromDate = new Date();

            if (
              (fundnametype === "Equity" && fundSubName !== "Equity - ELSS") ||
              (fundnametype === "Hybrid" &&
                fundSubName !== "Hybrid - Arbitrage")
            ) {
              fromDate.setMonth(fromDate.getMonth() - 12);
            } else if (
              fundnametype === "Debt" ||
              fundnametype === "Hybrid - Arbitrage" ||
              fundnametype === "Others"
            ) {
              // keep current
            } else {
              fromDate.setMonth(fromDate.getMonth() - 36);
            }

            const validTypes = [
              "SIP Purchase",
              "Purchase",
              "STP In",
              "Switch In",
            ];

            txns.forEach((tx) => {
              const parts =
                tx["Transaction Date"]?.replace(/-/g, "/")?.split("/") || [];

              if (parts.length === 3) {
                let [dd, mm, yy] = parts;
                if (yy.length === 2) yy = "20" + yy;
                const txDate = new Date(`${yy}-${mm}-${dd}`);

                if (
                  !isNaN(txDate) &&
                  validTypes.includes(tx["Transaction Type"]) &&
                  txDate < fromDate
                ) {
                  total += parseFloat(tx["Current Value"] || 0);
                }
              }
            });
          });
        });
      });
    });

    return Number(total.toFixed(2));
  };

  // Top of component
  const [expandedSubKey, setExpandedSubKey] = React.useState(null);

  // const handleEyeClick = (subKey, e) => {
  //   e?.stopPropagation?.(); // row click se conflict avoid
  //   setExpandedSubKey((prev) => (prev === subKey ? null : subKey));
  // };

  const handleEyeClick = async (fundId, folioId, subKey, e) => {
    e.stopPropagation();

    // ✅ Generate unique key from fundId + folioId
    const key = subKey;

    // ✅ Collapse if already expanded
    if (expandedRowKey === key) {
      setExpandedRowKey(null);
      return;
    }

    // ✅ Show cached data instantly
    if (folioData[key]) {
      setExpandedRowKey(key);
      return;
    }

    // ✅ Start loader
    setExpandedRowKey(key);
    setLoadingRowKey(key);

    try {
      const payload = { FundId: fundId, FolioID: folioId };
      const response = await api.post("advisor/getTransectionWM", payload);
      const data = response?.data || {};
      const transactions = Array.isArray(data.transactions)
        ? data.transactions
        : [];
      const transactionTotal = data.transactionTotal || null;

      setFolioData((prev) => ({
        ...prev,
        [key]: { transactions, transactionTotal },
      }));
    } catch (error) {
      console.error("❌ Error fetching transaction data:", error);
    } finally {
      setLoadingRowKey(null);
    }
  };




  const renderTableRows = (data, level = 0) => {
    if (!data?.categories || data.categories.length === 0) {
      return (
        <tr>
          <td colSpan="8" className="text-center">
            No Data Found
          </td>
        </tr>
      );
    }

    return data.categories.map((category, catIndex) => {
      const mainKey = `${level}-${catIndex}`;

      // 🛠️ Utility for calculating fromDate
      const getFromDate = (fundType, subType) => {
        let fromDate = new Date();

        if (
          (fundType === "Equity" && subType !== "Equity - ELSS") ||
          (fundType === "Hybrid" && subType !== "Hybrid - Arbitrage")
        ) {
          fromDate.setFullYear(fromDate.getFullYear() - 1); // -12 months
        } else if (
          fundType === "Debt" ||
          fundType === "Hybrid - Arbitrage" ||
          fundType === "Others"
        ) {
          // today
        } else {
          fromDate.setFullYear(fromDate.getFullYear() - 3); // -36 months
        }

        return fromDate.toISOString().split("T")[0]; // YYYY-MM-DD
      };

      return (
        <React.Fragment key={mainKey}>
          {/* <tr  className="border-bottom">
            <td className="" colSpan={8}>
              {data.username}
            </td>
          </tr> */}
          {/* ===== Category Row ===== */}
          <tr onClick={() => toggleRow(mainKey)} className="border-bottom">
            <td className="fs-14 trbgcolor fw-bold">
              <p className="m-1">{category.category}</p>
            </td>
            <td className="fs-14 fw-normal align-middle trbgcolor text-end">
              {formatRupees(category.totalInvCost)}
            </td>
            <td className="fs-14 fw-normal align-middle trbgcolor text-end">
              {formatRupees(category.totalMarketValue)}
            </td>
            <td className="fs-14 fw-normal align-middle trbgcolor text-end">
              {formatRupees(category.totalGainLoss)}
            </td>
            {/* <td className="fs-14 fw-normal align-middle trbgcolor text-end">{calculateTotalFloat(category.xirr).toFixed(2)}%</td> */}
            <td className="fs-14 fw-normal align-middle trbgcolor text-end">-</td>
            <td className="fs-14 fw-normal align-middle trbgcolor text-end">{calculateTotalFloat(category.absReturn).toFixed(2)}%</td>
            <td className="fs-14 fw-normal align-middle trbgcolor text-end">-</td>
            <td className="fs-14 fw-normal align-middle trbgcolor text-center">-</td>
          </tr>

          {/* ===== Funds under this category ===== */}
          {category.funds?.map((fund, fundIndex) => {
            const subKey = `${mainKey}-fund-${fundIndex}`;
            const subRowFolio = fund?.FolioNumber || "";
            const subRowISIN = fund?.ISIN || "";

            const fundIdstx = fund?.FundID || "";
            const folioIdstx = fund?.FolioID || "";


            // console.log('fund', fund)

            const goalName = getGoalDetail(subRowFolio, subRowISIN)?.goalName || "Unmapped";
            // console.log('clientreviewedfolioData', subRowFolio, subRowISIN);

            const safeGetClientReviewed = (folio, isin) => {
              if (!folio || !isin) return null;   // 🔥 prevent invalid lookups
              return getClientreviewedfolio(folio, isin) || null;
            };

            const clientreviewedfolioData = safeGetClientReviewed(subRowFolio, subRowISIN);

            const goalDetails = getGoalDetail(subRowFolio, subRowISIN);
            console.log('clientreviewedfolioData', clientreviewedfolioData);

            const effiBal = calculateEffectiveBalance(
              fund?.transactions,
              fund?.FundType,
              fund?.Sub_Category
            );
            console.log('category', effiBal, fund);

            const rowKey = `${subRowFolio}_${subRowISIN}`;
            const safeRowActions = rowActions || {}; // ✅ ensure it's always an object
            const actionHTML =
              safeRowActions[rowKey] ||
              clientreviewedfolioData?.recommended_action ||
              "";

            console.log("actionHTML", { rowKey, actionHTML, safeRowActions });


            return (
              <React.Fragment key={subKey}>
                <tr className="border-bottom">
                  <td
                    style={{ paddingLeft: `${(level + 1) * 10}px` }}
                    className="fs-14 py-3 fw-normal align-middle"
                  >

                    <span className="fs-12">
                      {fund.FundName || "No Sub Name"} &nbsp;
                      {/* {isAllowedreview && isPrst === "Draft" && (
                        <FaEdit
                          onClick={() => handleEditClick(subRowFolio, subRowISIN, fund)}
                          className="text-success fs-6"
                        />
                      )} */}
                      {/* {allowedReview &&
                        <FaEdit
                          onClick={() => { handleEditClick(subRowFolio, subRowISIN, fund); }}
                          className="text-success fs-6"
                          style={{ cursor: "pointer" }}
                          title="Edit"
                        />
                      }
                      &nbsp;
                      <FaEye
                        onClick={(e) => handleEyeClick(fundIdstx, folioIdstx, subKey, e)}
                        className="text-primary fs-6 ms-2"
                      /> */}

                      <p className="fs-12 mb-0 fw-bold">
                        Start Date: {getFromDate(fund.FundType, fund.Sub_Category)}
                      </p>
                      <p>
                        {clientreviewedfolioData?.portfolio_type_sip === 1 && "(SIP)"}
                      </p>
                    </span>
                  </td>

                  <td className="fs-14 py-3 fw-normal align-middle text-end">
                    {formatRupees(fund.InvCost)}
                  </td>
                  <td className="fs-14 py-3 fw-normal align-middle text-end">
                    {/* {formatRupees(fund.MarketValue)} */}
                    {isChecked ? formatRupees(effiBal) : formatRupees(fund.MarketValue)}
                  </td>
                  <td className="fs-14 py-3 fw-normal align-middle text-end">
                    {formatRupees(fund.GainLoss)}
                  </td>
                  <td className="fs-14 py-3 fw-normal align-middle text-end">
                    {fund.CAGR}%
                  </td>
                  <td className="fs-14 py-3 fw-normal align-middle text-end">
                    {fund.AbsRtn}%
                  </td>
                  <td className="fs-14 fw-normal align-middle text-end">{goalName}</td>
                  <td className="fs-14 py-3 fw-normal align-middle text-center" style={{ width: "5%" }}>
                    {actionHTML ? (
                      <>
                        <div
                          className="d-inline cursor-pointer"
                          style={{cursor: "pointer"}}
                          onClick={() => { fetchViewPrErrors(clientreviewedfolioData?.pr_row_id) }}
                          dangerouslySetInnerHTML={{ __html: actionHTML }}
                        />
                        {/* <span>
                          {clientreviewedfolioData?.action !== "none" && (
                            <IoInformationCircleOutline
                              className="ms-2"
                              onClick={() => showFundDetails(fund.FundName, goalName, goalDetails.goalYear, goalDetails.startYear, fund.ISIN)}
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </span> */}
                      </>
                    ) : (
                      "No Action required"
                    )}
                    {/* {(() => {
                      console.log('rowActions',actionHTML,subRowFolio)
                      const rowKey = `${subRowFolio}_${subRowISIN}`;
                      const actionHTML =rowActions[rowKey] || getClientreviewedfolio(subRowFolio, subRowISIN)?.recommended_action ||"";
                      console.log('rowKey',subRowFolio,subRowISIN,actionHTML)
                      // const schemeCodeData = schemeCode[rowKey];
                      // const hasAction = actionHTML.trim() !== "";

                      return (
                        <>
                          {actionHTML ? (
                            <>
                            <div
                              onClick={() =>
                                setShowActionFormModal(true)
                              }
                              dangerouslySetInnerHTML={{
                                __html: actionHTML,
                              }}
                            />
                            
                            </>
                          ):"No Action required"}
                          </>
                          )
          })} */}

                  </td>
                </tr>

                {/* ==== Transactions for each Fund ==== */}
                {expandedRowKey === subKey && (
                  <tr>
                    <td colSpan="10" className="p-2 bg-light">
                      {loadingRowKey === subKey ? (
                        <div className="text-center py-2">Loading transactions...</div>
                      ) : folioData[subKey]?.transactions?.length ? (
                        <table className="table table-sm mb-0">
                          <thead>
                            <tr>
                              <th>Txn Type</th>
                              <th>Date</th>
                              <th>Amount</th>
                              <th>Price</th>
                              <th>Units</th>
                            </tr>
                          </thead>
                          <tbody>
                            {folioData[subKey].transactions.map((txn, tIndex) => (
                              <tr key={tIndex}>
                                <td className="fs-12">{txn.Description}</td>
                                <td className="fs-12">{txn.TransactionDate}</td>
                                <td className="fs-12">
                                  {txn.CreditAmount !== "0"
                                    ? txn.CreditAmount
                                    : txn.DebitAmount}
                                </td>
                                <td className="fs-12">{txn.TradePrice}</td>
                                <td className="fs-12">
                                  {txn.CreditUnits !== "0"
                                    ? txn.CreditUnits
                                    : txn.DebitUnits}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <tr className="fw-bold bg-light">
                              <td colSpan="2">Total</td>
                              <td>
                                {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                  ?.Purchases || "-"}
                              </td>
                              <td>
                                {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                  ?.AvgCost || "-"}
                              </td>
                              <td>
                                {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                  ?.UnitsHeld || "-"}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      ) : (
                        <div className="text-center py-2">No transactions found.</div>
                      )}
                    </td>
                  </tr>
                )}

              </React.Fragment>
            );
          })}
        </React.Fragment>
      );
    });
  };

  const [openItems, setOpenItems] = useState({});

  // Function to toggle a specific scheme
  const toggleItem = (index) => {
    setOpenItems((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle the specific index
    }));
  };


  console.log('userData', userData);

  return (
    <>
      {/* <div className="scroll-container d-none d-md-block"> */}
      <table className="table align-middle mb-0 d-none d-md-table  ">
        <caption className="fw-bold txt-color p-2 mt-2"
        >
          {userData?.username || ""}
        </caption>

        <colgroup>
          <col style={{ width: "20%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "14%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "16%" }} />
        </colgroup>
        <thead className="sticky-header">
          <tr className="">
            <th scope="col" className="back-clrgreen txt-color-revers">
              Fund Name
            </th>

            <th scope="col" className="back-clrgreen txt-color-revers text-end">
              Inv Cost
            </th>

            <th scope="col" className="back-clrgreen txt-color-revers">
              <div className="d-flex align-items-center justify-content-center gap-2">
                <span className="text-nowrap">{isChecked ? "Load Free Unit" : "Current Value"}</span>

                {onlyone === "yes" && (
                  <div className="form-check form-switch m-0 toggle-color">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="valueToggle"
                      checked={isChecked}
                      onChange={handleToggle}
                      aria-label="Toggle between Current Value and Load Free Unit"
                    />
                  </div>
                )}
              </div>
            </th>

            <th scope="col" className="back-clrgreen txt-color-revers text-end">
              Gain/Loss
            </th>
            <th scope="col" className="back-clrgreen txt-color-revers text-end">
              XIRR
            </th>
            <th scope="col" className="back-clrgreen txt-color-revers text-end text-nowrap">
              Abs Rtn
            </th>
            <th scope="col" className="back-clrgreen txt-color-revers text-end">
              Goal
            </th>
            <th scope="col" className="back-clrgreen txt-color-revers text-center">
              Action
            </th>
          </tr>
        </thead>
        <tbody>{renderTableRows(userData)}</tbody>

        {userData?.categories?.length > 0 && (
          <>
            {/* ✅ Overall Total */}
            <tfoot>
              <tr>
                <th className="total-cell txt-color"> Total</th>
                <th className="total-cell text-end txt-color">
                  {/* {formatRupees(
            userData.categories.reduce((sum, cat) => sum + (Number(cat.totalInvCost )|| 0), 0)
          )} */}
                  {formatRupees(Number(userData?.userTotal?.totalInvCost))}
                </th>
                <th className="total-cell text-end txt-color">
                  {formatRupees(Number(userData?.userTotal?.totalMarketValue))}
                </th>
                <th className="total-cell text-end txt-color">
                  {formatRupees(Number(userData?.userTotal?.totalGainLoss))}
                </th>
                <th className="total-cell text-end txt-color">
                  {calculateTotalFloat(Number(userData?.userTotal?.xirr).toFixed(2))}%
                </th>
                <th className="total-cell text-end txt-color ">
                  {calculateTotalFloat(Number(userData?.userTotal?.absReturn).toFixed(2))}%
                </th>
                <th className="total-cell"></th>
                <th className="total-cell"></th>
              </tr>
            </tfoot>
          </>
        )}

      </table>
      {/* </div> */}

      {/* Mobile table */}

      <div className="d-block d-md-none">
        {userData?.categories?.map((category, catIdx) => (
          <div key={catIdx} className="mb-3">
            {/* Category Header */}
            <h6 className="fw-bold text-success mb-2">{category.category}</h6>

            {/* Funds List */}
            {category.funds?.map((fund, fundIdx) => {
              const fundKey = `${catIdx}-${fundIdx}`;
              const isOpen = openFunds[fundKey] || false;

              return (
                <div
                  key={fundKey}
                  className="card shadow-sm border mb-2"
                >
                  {/* Card Header */}
                  <div
                    className="card-header d-flex justify-content-between align-items-center bg-white"
                    onClick={() => toggleFund(fundKey)}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="fw-semibold text-truncate">{fund.FundName}</span>
                    {isOpen ? (
                      <FaMinus className="text-danger" />
                    ) : (
                      <FaPlus className="text-success" />
                    )}
                  </div>

                  {/* Card Body (expand on click) */}
                  {isOpen && (
                    <div className="card-body p-2">
                      {[
                        ["Investment Cost", formatRupees(fund.InvCost)],
                        ["Current Value", formatRupees(fund.MarketValue)],
                        ["Gain/Loss", formatRupees(fund.GainLoss)],
                        ["XIRR", `${fund.CAGR}%`],
                        ["Absolute Return", `${fund.AbsRtn}%`],
                      ].map(([label, value], idx) => (
                        <div
                          key={idx}
                          className="d-flex justify-content-between border-bottom py-1"
                        >
                          <span className="fw-bold text-muted small">{label}</span>
                          <span className="small">{value}</span>
                        </div>
                      ))}

                      {/* ✅ Transactions Row with Plus/Minus */}
                      <div
                        className="d-flex justify-content-between border-bottom py-1"
                        onClick={() => toggleTransaction(fundKey)}
                        style={{ cursor: "pointer" }}
                      >
                        <span className="fw-bold text-muted small">Transactions</span>
                        {openTransactions[fundKey] ? (
                          <FaMinus className="text-danger small" />
                        ) : (
                          <FaPlus className="text-success small" />
                        )}
                      </div>

                      {/* ✅ Transactions Table (expand on click) */}
                      {openTransactions[fundKey] && (
                        <div className="table-responsive mt-2">
                          <table className="table table-bordered table-sm">
                            <thead>
                              <tr className="table-light">
                                <th>Type</th>
                                <th>Date</th>
                                <th className="text-end">Investment</th>
                                <th className="text-end">Current</th>
                                <th className="text-end">Gain/Loss</th>
                                <th className="text-end text-nowrap">Abs Rtn</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Array.isArray(fund.transactions) && fund.transactions.length > 0 ? (
                                fund.transactions.map((tx, txIdx) => (
                                  <tr key={txIdx}>
                                    <td>{tx?.Description || "N/A"}</td>
                                    <td>{tx?.TransactionDate || "N/A"}</td>
                                    <td className="text-end">{formatRupees(tx?.inv_amount || 0)}</td>
                                    <td className="text-end">{formatRupees(tx?.curr_val || 0)}</td>
                                    <td className="text-end">{formatRupees(tx?.gain_loss || 0)}</td>
                                    <td className="text-end">
                                      {tx?.abs_return ? tx.abs_return.toFixed(2) : "N/A"}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="6" className="text-center">
                                    No Transactions Available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>

                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>

     

      <ActionFormModal
        show={showActionFormModal}
        content={"No Form created"}
        onHide={() => {
          setShowActionFormModal(false);
          setViewPrErrors([]);
        }}
        roomId={roomId}
        prRowId={prRowId}
        viewPrErrors={viewPrErrors}
        setViewPrErrors={setViewPrErrors}
      />

      {/* <ActionFormModal
            show={showActionFormModal}
            content={"No Form created"}
        onHide={() => { setShowActionFormModal(false); setViewPrErrors([])}}
            roomId={roomId}
        prRowId={prRowId}
        viewPrErrors={viewPrErrors} setViewPrErrors={setViewPrErrors}
          /> */}

      <FundDetailsModal
        show={showActionModal}
        onHide={() => setShowActionModal(false)}
        content={modalContent}
      />

      <div className="d-block d-md-none">
        {userData?.[0] && (
          <div className="border border-1 rounded-3 p-3 mb-3 bg-white shadow-sm">
            {/* Header */}
            <div
              className="d-flex justify-content-between align-items-center mb-3"
              onClick={() => toggleItem(userData[0]?.Name)}
              style={{ cursor: "pointer" }}
            >
              <h5 className="fs-16 fw-bold m-0 d-flex align-items-center justify-content-between gap-2">
                <span>{userData[0]?.Name}</span>
              </h5>
              <span>
                {openItems[userData[0]?.Name] ? (
                  <FaMinus className="text-danger" />
                ) : (
                  <FaPlus className="text-success" />
                )}
              </span>
            </div>


          </div>
        )}

        <FundDetailsModal
          show={showModal}
          onHide={() => setShowModal(false)}
          content={modalContent}
        />
      </div>
    </>
  );
}
